<template>
  <v-container
    fluid
    class="pa-0 grey lighten-4"
    style="flex-direction: column; overflow: hidden"
  >
    <ArmariosToolbar
      :listaModo="listaModo"
      :isMobile="!$vuetify.breakpoint.mdAndUp"
      :verPlanos="puedeVerPlanos"
      @toggle-drawer="drawerOpen = !drawerOpen"
      @change-modo="onChangeModo"
      @open-scanner="showScanner = true"
    />

    <div class="d-flex flex-grow-1" style="overflow: hidden">
      <ArmariosDrawer
        v-model="drawerOpen"
        :isDesktop="$vuetify.breakpoint.mdAndUp"
        :listaModo="listaModo"
        :treeData="treeData"
        :selectedNode="selectedNode"
        :planosData="planosData"
        :selectedPlano="selectedPlano"
        @select-node="selectNode"
        @toggle-node="toggle"
        @select-plano="selectPlano"
        @plano-creado="fetchPlanos"
      />
      <main class="main-workspace flex-grow-1">
        <ArmariosTreeView
          v-if="listaModo === 'armarios'"
          :treeData="treeData"
          :usuarios="usuarios"
          :selectedNode="selectedNode"
          :searchQueryId="treeSearchQuery"
          :verPlanos="puedeVerPlanos"
          :puedeEditar="puedeEditar"
          :puedeAdjuntar="puedeAdjuntar"
          @cambiar-padre="cambiarPadre"
          @crear-armario-raiz="crearArmarioRaizFromChild"
          @select-node="selectNode"
          @clear-selected="clearSelectedNode"
          @update:searchQueryId="treeSearchQuery = $event"
          @add-subnode="crearHijo"
          @edit-title="editTitle"
          @remove-node="removeNode"
          @attach-file="attachFile"
          @view-files="viewFiles"
          @ver-plano="verPlano"
          @ver-qr="verQR"
          @toggle="toggle"
        />

        <ArmariosPlanosView
          v-else
          :selectedPlano="selectedPlano"
          :armarios="treeData"
          :planosData="planosData"
          @click_plano="click_plano"
          @ver-en-arbol="verArmarioEnArbol"
          @ver-en-plano="verArmarioEnPlano"
          @add-adjunto="openAttachFromAdjuntos"
          @ir-a-subplano="irASubPlano"
          @fetch="fetchTree"
        />
      </main>
    </div>
    
    <ArmariosDialogs
      :snackbar.sync="snackbar"
      :snackbarText="snackbarText"
      :snackbarColor="snackbarColor"
      :attachDialog.sync="attachDialog"
      :crearSubnodoDialog.sync="crearSubnodoDialog"
      :editarNodoDialog.sync="editarNodoDialog"
      :dialogPlanos.sync="dialogPlanos"
      :dialogElegirPlano.sync="dialogElegirPlano"
      :showScanner.sync="showScanner"
      :dialogVerQR.sync="dialogVerQR"
      :nodoParaQR="nodoParaQR"
      :nodoSeleccionadoParaAdjunto="nodoSeleccionadoParaAdjunto"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      :nodoEditando="nodoEditando"
      :selectedAdjuntos="selectedAdjuntos"
      :adjuntos="adjuntos"
      :articulos="articulos"
      :planoYposicion="planoYposicion"
      :selectedPlano="selectedPlano"
      :planosData="planosData"
      :nodoParaCrearHijo="nodoParaCrearHijo"
      :dialogSeleccionarArmario="dialogSeleccionarArmario"
      :armarios="treeData"
      :verPlanos="puedeVerPlanos"
      :puedeEditar="puedeEditar"
      :puedeAdjuntar="puedeAdjuntar"
      :puedeEliminar="puedeEliminarAdjunto"
      @upload="handleFileUpload"
      @save-subnode="guardarSubnodo"
      @guardar-edicion="guardarEdicionNodo"
      @cerrar-planos="cerrarDialogPlanos"
      @decode="onDecode"
      @imprimir-qr="imprimirQR"
      @close-adjuntos="closeAdjuntosLista"
      @refresh-adjuntos="refreshAdjuntos"
      @select-plano-store="selectPlanoStore"
      @plano-creado="fetchPlanos"
      @select="select"
      @crear-nuevo-tipo="crearNuevoTipo"
      @add-adjunto="openAttachFromAdjuntos"
      @ver-en-plano="verArmarioEnPlano"
      @ver-en-arbol="verArmarioEnArbol"
      @cambiar-estado-dialog="cambiarEstadoDialog"
      @cambiar-padre-de-armario="cambiarPadreDeArmario"
      @ir-a-subplano="irASubPlano"
      @fetch="fetchTree"

    />
  </v-container>
</template>

<script>
import ArmariosToolbar from "./layout/ArmariosToolbar.vue";
import ArmariosDrawer from "./layout/ArmariosDrawer.vue";
import ArmariosTreeView from "./views/ArmariosTreeView.vue";
import ArmariosPlanosView from "./views/ArmariosPlanosView.vue";
import ArmariosDialogs from "./dialogs/ArmariosDialogs.vue";

import axios from "axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "Armarios",
  components: {
    ArmariosToolbar,
    ArmariosDrawer,
    ArmariosTreeView,
    ArmariosPlanosView,
    ArmariosDialogs,
  },
  data() {
    return {
      // UI
      drawerOpen: false,
      listaModo: "armarios",

      snackbar: false,
      snackbarText: "",
      snackbarColor: null,

      //ListaArmarios
      dialogSeleccionarArmario: false,

      // QR
      showScanner: false,
      dialogVerQR: false,
      nodoParaQR: null,

      // Planos
      planosData: [],
      selectedPlano: null,
      selectedRegion: null,
      planoYposicion: {},
      dialogPlanos: false,
      dialogElegirPlano: false,
      nodoTemporal: null,
      nodoParaPlano: null, // por si lo usabas antes

      // Dialogs / Edición
      editarNodoDialog: false,
      nodoEditando: {},
      nuevoTipoTexto: "",
      nuevoTipoBanner: null,

      crearSubnodoDialog: false,
      nuevoNombreSubnodo: "",
      nuevoTipoSeleccionado: null, // <- NECESARIO para bannerTipoSeleccionado
      tiposSubnodo: [],
      nodoParaCrearHijo: null,

      // Adjuntos
      tiposAdjunto: [],
      tiposNodo: [],
      attachDialog: false,
      nodoSeleccionadoParaAdjunto: null,
      adjuntos: [],
      articulos: [],
      selectedAdjuntos: null,

      // Árbol
      treeData: [],
      selectedNode: null,
      treeSearchQuery: "",

      // Contexto
      idCliente: null,

      // Compat (por si algo aún lo usa)
      nuevoArmario: "",
    };
  },
  computed: {
    ...mapState(["user", "usuarios", "esRamos", "permisos"]),
    ...mapState("armarios", ["regionSeleccionada"]),
    bannerTipoSeleccionado() {
      const tipo = this.tiposNodo.find((t) => t.id === this.nuevoTipoSeleccionado);
      if (tipo && tipo.banner_url) {
        return `/api/nodejs${tipo.banner_url}`;
      }
      return null;
    },

    puedeEditar(){
      return this.permisos.includes('editar-armarios');
    },
    puedeVerPlanos(){
      return this.permisos.includes('ver-planos');
    },
    puedeAdjuntar(){
      return this.permisos.includes('anadir-archivo');
    },
    puedeEliminarAdjunto(){
      return this.permisos.includes('eliminar-archivo');
    }
  },
  watch: {
    listaModo(newMode) {
      if (newMode !== "planos") {
        this.setRegionNueva(null);
      }
    },
    "$route.query": {
      deep: true,
      async handler(newQuery) {
        if (newQuery.client_id && newQuery.client_id != this.idCliente) {
          await this.inicializarVista();
        } else if (newQuery.qr) {
          this.procesarLecturaQR(newQuery.qr);
        }
      },
    },
  },
  async mounted() {
    await this.inicializarVista();
  },
  methods: {
    ...mapActions(["setUsuarios", "setClientId"]),
    ...mapActions("armarios", ["setRegionSeleccionada", "setSelectedPlano", "setRegionNueva","setSelectedNode"]),

    // ====== Control modo ======
    onChangeModo(modo) {
      this.listaModo = modo;
      this.clearSelectedNode();
      this.clearSearchQuery();
      if (modo === "planos") this.entrarModoPlanos();
      else this.selectedPlano = null;
    },

    entrarModoPlanos() {
      this.listaModo = "planos";
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.selectedPlano = null;
      }
    },

    // ====== Init ======
    async inicializarVista() {
      this.idCliente =
        this.$route.query.client_id || localStorage.getItem("clienteSeleccionado") || 1;

      this.fetchTiposAdjunto();
      this.fetchUsuarios();
      this.fetchTiposNodo();
      await this.fetchTree();
      await this.fetchPlanos();

      const qrEnUrl = this.$route.query.qr;
      if (qrEnUrl) {
        if (this.esRamos) {
          const res = await axios.get(
            `/api/nodejs/armarios/cliente/${qrEnUrl}`
          );
          const idDetectado = res.data?.client_id;
          this.idCliente = idDetectado;
        }
        this.procesarLecturaQR(qrEnUrl);
      }
    },

    // ====== Fetch ======
    async fetchPlanos() {
      try {
        const response = await axios.get(
          `/api/nodejs/planos`,
          { params: { id_cliente: this.idCliente } }
        );
        this.planosData = response.data || [];
      } catch (error) {
        console.error("Error al cargar planos", error);
      }
    },

    async fetchTree() {
      try {
        const id_usuario = this.user?.id || JSON.parse(localStorage.getItem("user"))?.id;
        const response = await axios.get(
          `/api/nodejs/armarios`,
          { params: { id_cliente: this.idCliente, id_usuario } }
        );
        this.treeData = response.data.armarios || [];
      } catch (err) {
        console.error("Error al cargar árbol:", err);
      }
    },

    fetchUsuarios() {
      axios
        .get(`/api/django/portal/get_all_users`)
        .then((response) => this.setUsuarios(response.data.users || []))
        .catch((error) => console.error("Error al cargar usuarios:", error));
    },

    fetchTiposAdjunto() {
      axios
        .get(`/api/nodejs/armarios/tipos_adjuntos`)
        .then((response) => (this.tiposAdjunto = response.data.tipos || []))
        .catch((error) => console.error("Error al cargar tipos de adjuntos:", error));
    },

    fetchTiposNodo() {
      axios
        .get(`/api/nodejs/armarios/tipos`)
        .then((response) => (this.tiposNodo = response.data.tipos_armarios || []))
        .catch((error) => console.error("Error al cargar tipos de nodo:", error));
    },

    // ====== Árbol selección/expand ======
    clearSelectedNode() {
      this.selectedNode = null;
    },

    toggle(node) {
      node.expanded = !node.expanded;
    },

    findParentInTree(tree, node) {
      for (const n of tree) {
        if (n.id === node.id_parent) return n;
        const found = this.findParentInTree(n.children || [], node);
        if (found) return found;
      }
      return null;
    },

    expandParents(node) {
      let current = node;
      while (current && current.id_parent !== null) {
        const parent = this.findParentInTree(this.treeData, current);
        if (!parent) break;
        parent.expanded = true;
        current = parent;
      }
    },

    selectNode(node) {
      this.selectedNode = node;
      this.setSelectedNode(node)
      console.log("Nodo seleccionado:", node);

      const collapseAll = (nodes) => {
        nodes.forEach((n) => {
          n.expanded = false;
          if (n.children && n.children.length) collapseAll(n.children);
        });
      };

      collapseAll(this.treeData);
      this.expandParents(node);
    },

    // ====== Armarios CRUD ======
    crearArmarioRaizFromChild(nombre) {
      return this.crearArmarioRaiz(nombre);
    },

    async crearArmarioRaiz(nombre) {
      const name = (nombre || "").trim();
      if (!name) return;

      const newNode = {
        name,
        parent_id: null,
        x: 50,
        y: 250,
        expanded: true,
        children: [],
        id_cliente: this.idCliente,
        id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
      };

      try {
        await axios.post(`/api/nodejs/armarios`, newNode);
        await this.fetchTree();
        this.snackbarText = "Armario creado correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error("Error al crear armario:", error);
      }
    },

    async crearHijo(parentNode) {
      console.log(parentNode);
      this.nodoParaCrearHijo = parentNode;
      this.nuevoNombreSubnodo = "";
      this.nuevoTipoSeleccionado = null;
      this.nuevoTipoTexto = "";
      this.nuevoTipoBanner = null;
      this.crearSubnodoDialog = true;

      if (this.tiposSubnodo.length === 0) {
        try {
          const res = await axios.get(
            `/api/nodejs/armarios/tipos_adjuntos`
          );
          this.tiposSubnodo = res.data.tipos || [];
        } catch (error) {
          console.error("Error cargando tipos:", error);
        }
      }
    },

    async guardarSubnodo(payload) {
      const { nombre, tipoSeleccionado, tipoNuevoTexto, tipoNuevoBanner } = payload;

      if (!nombre || !nombre.trim()) {
        alert("Debes poner un nombre para el subnodo");
        return;
      }

      let tipoFinal = tipoSeleccionado;

      // Crear tipo nuevo con banner
      if (!tipoFinal && tipoNuevoTexto && tipoNuevoTexto.trim()) {
        try {
          if (!tipoNuevoBanner) {
            alert("Debes subir un banner para crear un nuevo tipo");
            return;
          }

          const formData = new FormData();
          formData.append("name", tipoNuevoTexto.trim());
          formData.append("banner", tipoNuevoBanner);

          const res = await axios.post(
            `/api/nodejs/armarios/tipos`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          tipoFinal = res.data.id;

          // refrescar tipos
          await this.fetchTiposNodo();
        } catch (err) {
          console.error(err);
          alert("No se pudo crear el tipo nuevo");
          return;
        }
      }

      if (!tipoFinal) {
        alert("Debes seleccionar o crear un tipo");
        return;
      }

      try {
        const payloadSubnodo = {
          name: nombre,
          id_parent: this.nodoParaCrearHijo.id,
          id_tipo: tipoFinal,
          x: (this.nodoParaCrearHijo.x || 0) + 150,
          y: (this.nodoParaCrearHijo.y || 0) + 100,
          id_cliente: this.idCliente,
          id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          tipo: tipoFinal,
          expanded: true,
        };

        const res = await axios.post(
          `/api/nodejs/armarios`,
          payloadSubnodo
        );

        await this.fetchTree();

        this.selectNode({
          id: res.data.id,
          name: nombre,
          id_parent: this.nodoParaCrearHijo.id,
          x: payloadSubnodo.x,
          y: payloadSubnodo.y,
          expanded: true,
          children: [],
          id_usuario: payloadSubnodo.id_usuario,
          tipo: tipoFinal,
        });

        this.crearSubnodoDialog = false;
      } catch (error) {
        console.error("Error al crear subnodo:", error);
        alert("Error al crear subnodo");
      }
    },

    async editTitle(node) {
      this.nodoEditando = { ...node };

      if (typeof node.tipo === "string") {
        const partes = node.tipo.replace(/[()"]/g, "").split(",");
        this.nodoEditando.tipoId = Number(partes[0]);
      } else {
        this.nodoEditando.tipoId = node.tipoId || node.id_tipo || null;
      }

      this.editarNodoDialog = true;
    },

    async guardarEdicionNodo() {
      try {
        const copiaNodo = { ...this.nodoEditando };

        await axios.put(
          `/api/nodejs/armarios/${this.nodoEditando.id}`,
          {
            name: this.nodoEditando.name,
            tipoId: this.nodoEditando.tipoId,
            id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          }
        );

        this.editarNodoDialog = false;
        await this.fetchTree();

        this.snackbarText = "Nodo actualizado correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.selectNode(copiaNodo);
      } catch (err) {
        console.error(err);
      }
    },

    crearNuevoTipo() {
      // si lo necesitas, aquí iría la lógica de creación manual desde el dialog editar
      console.log("crearNuevoTipo", this.nuevoTipoTexto, this.nuevoTipoBanner);
    },

    findRealParent(node) {
      if (!node || !node.id_parent) return null;
      for (const n of this.treeData) {
        if (n.id === node.id_parent) return n;
        const found = this.findParentInTree(n.children || [], node);
        if (found) return found;
      }
      return null;
    },

    findParentInTree(tree, node) {
      for (const n of tree) {
        if (n.id === node.id_parent) return n;
        const found = this.findParentInTree(n.children || [], node);
        if (found) return found;
      }
      return null;
    },

    async removeNode(node) {
      if (!confirm(`¿Estás seguro de que quieres eliminar el armario "${node.name}"?`)) return;

      try {
        await axios.delete(
          `/api/nodejs/armarios/${node.id}`
        );

        const parent = this.findRealParent(node);
        if (parent) {
          parent.children = (parent.children || []).filter((child) => child.id !== node.id);
        }

        await this.fetchTree();
        if (parent) this.selectNode(parent);
      } catch (error) {
        console.error("Error al eliminar armario:", error);
      }
    },

    // ====== Adjuntos ======
    attachFile(node) {
      this.nodoSeleccionadoParaAdjunto = node;
      this.attachDialog = true;
    },

    async handleFileUpload(payload) {
      const { nombreArchivo, descripcionArchivo, archivoAdjunto } = payload;

      if (!archivoAdjunto || !nombreArchivo || !nombreArchivo.trim()) {
        alert("Por favor, selecciona un archivo y proporciona un nombre.");
        return;
      }

      const formData = new FormData();
      formData.append("archivo", archivoAdjunto);
      formData.append("name", nombreArchivo);
      formData.append("description", descripcionArchivo || "");
      formData.append("id_usuario", this.user?.id || JSON.parse(localStorage.getItem("user"))?.id);
      formData.append("tipo", "armario");

      try {
        await axios.post(
          `/api/nodejs/armarios/${this.nodoSeleccionadoParaAdjunto.id}/adjuntos`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        await this.fetchTree();
        this.snackbarText = "Archivo subido correctamente";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.selectNode(this.nodoSeleccionadoParaAdjunto);

        this.attachDialog = false;
       
        if (this.selectedAdjuntos && this.selectedAdjuntos.id === this.nodoSeleccionadoParaAdjunto?.id) {
          this.viewFiles(this.selectedAdjuntos);
        }
         this.nodoSeleccionadoParaAdjunto = null;
      } catch (error) {
        console.error("Error al adjuntar archivo:", error);
        alert("Error al adjuntar archivo");
      }
    },

    async viewFiles(node) {
      try{
        const [adjuntosResponse, articulosResponse] = await Promise.all([
          axios.get(`/api/nodejs/armarios/${node.id}/adjuntos`),
          axios.get(`/api/nodejs/articulos/articulos-armarios/${node.id}`)
        ]);

        //ADJUNTOS
        this.adjuntos = adjuntosResponse.data.adjuntos || [];
        this.adjuntos.forEach((adjunto) => {
          adjunto.usuario = this.usuarios.find((u) => u.id === adjunto.id_usuario) || {
            username: "Desconocido",
          };
        });

        //ARTICULOS
        this.articulos = (articulosResponse.data.articulos || []).map((articulo) => ({
          id: articulo.id,
          nombre: articulo.nombre,
          referencia: articulo.referencia,
        }));

        this.selectedAdjuntos = node;
      } catch (error){
        console.error("Error al obtener articulos o archivos adjuntos",error);
      }
    },

    refreshAdjuntos() {
      if (this.selectedAdjuntos) this.viewFiles(this.selectedAdjuntos);
    },

    async closeAdjuntosLista() {
      await this.fetchTree();
      if (this.selectedAdjuntos) this.selectNode(this.selectedAdjuntos);
      this.selectedAdjuntos = null;
      this.adjuntos = [];
      
    },

    // ====== Planos ======
    selectPlano(plano) {
      this.selectedPlano = plano;
      this.setSelectedPlano(plano);
      this.listaModo = "planos";
    },

    click_plano(plano) {
      this.selectNode(plano);
      this.viewFiles(plano);
      this.listaModo = "armarios";
    },

    async verPlano(nodo) {

      this.setRegionSeleccionada(nodo);

      try {
        const url = `/api/nodejs/planos/armario/${nodo.id}`;

        const resul = await axios.get(url);


        if (!resul.data || resul.data.length === 0) {
          const crear = window.confirm(
            "No hay plano asociado a este armario. \n¿Quieres crear uno nuevo?"
          );
          if (crear) {
            this.nodoTemporal = nodo;
            this.dialogElegirPlano = true;
            return;
          }
          this.snackbarText = "No hay plano asociado a este armario.";
          this.snackbarColor = "info";
          this.snackbar = true;
          return;
        }

        const infoPlano = resul.data[0];
        this.planoYposicion = infoPlano;
        this.selectedRegion = nodo;

        this.clearSearchQuery();
        this.clearSelectedNode();

        this.dialogPlanos = true;
      } catch (error) {
        console.error("[Armarios] Error en verPlano:", error);
      }
    },

    selectPlanoStore(plano) {
      this.setSelectedPlano(plano);
      this.setRegionNueva(this.nodoTemporal);
      this.dialogElegirPlano = false;
      this.selectedPlano = plano;

      this.$nextTick(() => {
        this.listaModo = "planos";
      });
    },

    cerrarDialogPlanos() {
      this.planoYposicion = {};
      this.nodoParaPlano = null;

      const tieneRegionSeleccionada =
        this.regionSeleccionada &&
        typeof this.regionSeleccionada === "object" &&
        (this.regionSeleccionada.id != null || this.regionSeleccionada.id_armario != null);

      if (tieneRegionSeleccionada) {
        this.setRegionSeleccionada(null);
      }

      this.dialogPlanos = false;
      //this.selectedPlano = null;
      if (this.listaModo == "armarios"){
        this.selectedPlano = null;
        this.setSelectedPlano(null);
      }
    },

    // ====== QR ======
    verQR(node) {
      this.nodoParaQR = node;
      this.dialogVerQR = true;
    },

    imprimirQR() {
      const elemento = document.getElementById("print-section");
      if (!elemento) return;

      const canvas = elemento.querySelector("canvas");
      let contenidoFinal = "";

      if (canvas) {
        const imagenData = canvas.toDataURL("image/png");
        const textoIdentificador =
          elemento.querySelector(".font-weight-black")?.innerText || "";

        contenidoFinal = `
          <div style="text-align:center; font-family: sans-serif;">
            <img src="${imagenData}" style="width:200px; height:200px;" />
            <div style="margin-top:10px; font-size: 18px; font-weight: bold;">${textoIdentificador}</div>
          </div>
        `;
      } else {
        contenidoFinal = elemento.innerHTML;
      }

      const ventana = window.open("", "_blank");
      ventana.document.write("<html><head><title>Imprimir QR</title></head><body>");
      ventana.document.write(contenidoFinal);
      ventana.document.write(
        `
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);
          };
        <` + "/script>"
      );
      ventana.document.write("</body></html>");
      ventana.document.close();
    },

    buscarNodoPorQR(nodos, codigoEscaneado) {
      for (const nodo of nodos) {
        if (nodo.qr_code === codigoEscaneado) return nodo;
        if (nodo.children && nodo.children.length > 0) {
          const encontrado = this.buscarNodoPorQR(nodo.children, codigoEscaneado);
          if (encontrado) return encontrado;
        }
      }
      return null;
    },

    procesarLecturaQR(contenidoLeido) {
      let codigoFinal = contenidoLeido;

      if (contenidoLeido && contenidoLeido.includes("?qr=")) {
        const urlParams = new URLSearchParams(contenidoLeido.split("?")[1]);
        codigoFinal = urlParams.get("qr");
      }

      const armario = this.buscarNodoPorQR(this.treeData, codigoFinal);

      if (armario) {
        this.selectNode(armario);
        this.viewFiles(armario);
      } else {
        this.snackbarText = "Armario no encontrado o no tienes permisos.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    async onDecode(codigoLeido) {
      this.showScanner = false;

      let codigo = null;
      try {
        codigo = new URL(codigoLeido).searchParams.get("qr");
      } catch (e) {
        codigo = codigoLeido;
      }

      const armarioEncontrado = this.buscarNodoPorQR(this.treeData, codigo);

      if (armarioEncontrado) {
        this.snackbarText = `Armario detectado: ${armarioEncontrado.name}`;
        this.snackbarColor = "success";
        this.snackbar = true;

        this.selectNode(armarioEncontrado);
        this.viewFiles(armarioEncontrado);
      } else {
        this.snackbarText = "El código QR no está vinculado a ningún armario.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    select(nodo) {
      this.planoYposicion = nodo;
    },
    irASubPlano(payload) {
      const localListaModo = this.listaModo
      const idPlanoDestino = payload?.id;
      if (!idPlanoDestino) {
        console.warn("No llegó id de subplano", payload);
        return;
      }

      const planoDestino = this.planosData.find((p) => String(p.id) === String(idPlanoDestino));

      if (!planoDestino) {
        console.warn("No se encontró el plano destino en planosData", idPlanoDestino);
        this.snackbarText = "No se encontró el subplano seleccionado";
        this.snackbarColor = "warning";
        this.snackbar = true;
        return;
      }

      this.selectPlano(planoDestino);
      this.listaModo = localListaModo
    },

    openAttachFromAdjuntos(region) {
      console.log("Abrir adjuntos para nodo:", region);
      // region es el armario/nodo actual
      this.nodoSeleccionadoParaAdjunto = region;
      this.attachDialog = true;
    },
    async verArmarioEnPlano(region) {
      await this.closeAdjuntosLista();
      this.verPlano(region);
    },
    async verArmarioEnArbol(region) {
      await this.closeAdjuntosLista();

      this.dialogPlanos = false;
      this.listaModo = "armarios";
      this.treeSearchQuery = `$${region.id}`;
      this.selectedPlano = null;

      this.$nextTick(() => {
        const nodo = this.findNodeById(this.treeData, region.id);
        if (nodo) {
          this.selectNode(nodo);
        } else {
          console.warn("No se encontró el nodo en el árbol con id:", region.id);
        }
      });
    },
    async clearSearchQuery() {
      this.treeSearchQuery = "";
    },
    cambiarPadre(nodo) {
      this.cambiarEstadoDialog(true);
      this.nodoParaCrearHijo = nodo;
    },
    cambiarEstadoDialog(estado) {
      this.dialogSeleccionarArmario = estado;
    },
    findNodeById(nodes, idBuscado) {
      for (const node of nodes) {
        if (String(node.id) === String(idBuscado)) return node;

        if (node.children && node.children.length) {
          const found = this.findNodeById(node.children, idBuscado);
          if (found) return found;
        }
      }
      return null;
    },
    async cambiarPadreDeArmario({idHijo, idNuevoPadre}){
      this.cambiarEstadoDialog(false);
      try{
        await axios.put(
          `/api/nodejs/armarios/${idHijo}/change-parent`,
          {
            id_parent: idNuevoPadre
          }
        );

        await this.fetchTree();
      } catch (error) {
        console.error("Error cambiando padre del armario");
      }
    }
  },
};
</script>

<style scoped>
.main-workspace {
  overflow-y: auto;
  height: 100%;
  background-color: #f5f7fa;
}
</style>